import type { IProduct, IProductDTO, IProductTax, IProductTaxDTO, IProductTaxDetailOutput, IProductTaxDetailOutputDTO } from '~models/Product';
import { convertToBrCurrency, convertToPercents } from '~/utils/textUtils';

export const adaptProduct = {
  fromAPI: adaptProductDTO,
};

export const adaptProductTax = {
  fromAPI: adaptProductTaxDTO,
};

export const adaptProductTaxDetailOutput = {
  fromAPI: adaptProductTaxDetailOutputDTO,
};

function adaptProductDTO(productDto: IProductDTO): IProduct {
  return {
    ...productDto,
    customerBilling: convertToBrCurrency(productDto.customerBilling),
    resellerBilling: convertToBrCurrency(productDto.resellerBilling),
  };
}

function adaptProductTaxDTO(productTaxDTO: IProductTaxDTO): IProductTax {
  return {
    ...productTaxDTO,
    issTotal: convertToBrCurrency(productTaxDTO.issTotal),
    icmsTotal: convertToBrCurrency(productTaxDTO.icmsTotal),
    pisTotal: convertToBrCurrency(productTaxDTO.pisTotal),
    cofinsTotal: convertToBrCurrency(productTaxDTO.cofinsTotal),
    ipiTotal: convertToBrCurrency(productTaxDTO.ipiTotal),
    productTaxDetailOutputDto: productTaxDTO.productTaxDetailOutputDto.map(adaptProductTaxDetailOutputDTO),
  };
}

function adaptProductTaxDetailOutputDTO(productTaxDetailOutputDTO: IProductTaxDetailOutputDTO): IProductTaxDetailOutput {
  return {
    ...productTaxDetailOutputDTO,
    issPercent: convertToPercents(productTaxDetailOutputDTO.issPercent),
    icmsPercent: convertToPercents(productTaxDetailOutputDTO.icmsPercent),
    pisPercent: convertToPercents(productTaxDetailOutputDTO.pisPercent),
    cofinsPercent: convertToPercents(productTaxDetailOutputDTO.cofinsPercent),
    ipiPercent: convertToPercents(productTaxDetailOutputDTO.ipiPercent),
    issValue: convertToBrCurrency(productTaxDetailOutputDTO.issValue),
    icmsValue: convertToBrCurrency(productTaxDetailOutputDTO.icmsValue),
    pisValue: convertToBrCurrency(productTaxDetailOutputDTO.pisValue),
    cofinsValue: convertToBrCurrency(productTaxDetailOutputDTO.cofinsValue),
    ipiValue: convertToBrCurrency(productTaxDetailOutputDTO.ipiValue),
  };
}
